import CheckIcon from '@mui/icons-material/Check';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import { IFilters } from 'Interfaces/general';
import { myCollectionFiltersState, myCollectionsState } from 'lib/recoil/atoms';

export const CollectionFilters = () => {
	const myCollections = useRecoilValue(myCollectionsState);
	const [myCollectionFilters, setMyCollectionFilters] = useRecoilState(myCollectionFiltersState);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleOnFilterClick = (e: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(e.currentTarget);
	};

	const handleOnFilterDelete = (key: IFilters) => {
		setMyCollectionFilters(null);
	};

	const handleOnFiltersClose = () => {
		setAnchorEl(null);
	};

	const handleMenuItemClick = (canisterId: string) => {
		setMyCollectionFilters(canisterId);
		setAnchorEl(null);
	};

	const findFilterLabel = () => {
		return myCollections.find(collection => collection.canisterId === myCollectionFilters)?.name ?? 'Collection';
	};

	const handleOnResetFilter = () => {
		// Reset filters and go back to first page
		setMyCollectionFilters(null);
	};

	return (
		<>
			<Grid container spacing={1}>
				<Grid item>
					<Chip
						label={findFilterLabel()}
						color='primary'
						variant={myCollectionFilters ? 'filled' : 'outlined'}
						onClick={handleOnFilterClick}
						onDelete={() => handleOnFilterDelete('collection')}
					/>
				</Grid>
				<Grid item>
					<Chip
						label='Reset filters'
						color='secondary'
						variant='outlined'
						onClick={handleOnResetFilter}
						onDelete={handleOnResetFilter}
					/>
				</Grid>
			</Grid>
			<Menu
				id={`collection-menu`}
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleOnFiltersClose}
				MenuListProps={{
					'aria-labelledby': `collection-button`,
					role: 'listbox'
				}}
			>
				{myCollections.map(collection => {
					const isSelected = myCollectionFilters === collection.canisterId;

					return (
						<MenuItem
							key={collection.canisterId}
							selected={isSelected}
							onClick={() => handleMenuItemClick(collection.canisterId)}
						>
							<ListItemIcon>
								{isSelected ? <CheckIcon color='primary' fontSize='small' /> : null}
							</ListItemIcon>
							{collection.name}
						</MenuItem>
					);
				})}
			</Menu>
		</>
	);
};
